/**
 * @see https://stackoverflow.com/a/23347763
 */
$.extend(
  {
    redirectPost: function(location, args, method)
    {
      if (!method) {
        method = 'POST';
      }

      var form = '';
      $.each( args, function( key, value ) {
        value = value.split('"').join('\"')
        form += '<input type="hidden" name="'+key+'" value="'+value+'">';
      });
      $('<form action="' + location + '" method="' + method + '">' + form + '</form>').appendTo($(document.body)).submit();
    }
  }
);
